import { PropertyType } from '@inspectify/core';
import { HomeFilled, JobCardPractice } from '@inspectify/design';
import { Box, Typography } from '@mui/material';
import React from 'react';

type PropertyProps = {
  property?: PropertyType
  imageStyle?: React.CSSProperties
  placeholderStyle?: React.CSSProperties
  showAddress?: boolean
  hideIfNoImage?: boolean
  isMock?: boolean
  palette?: string
};

/**
 * Property image component
 *
 * TODO: use : https://github.com/imgix/react-imgix?#readme
 *       create srcset for responsive images
 */
export const Property: React.FC<PropertyProps> = ({
  property,
  imageStyle,
  placeholderStyle,
  showAddress,
  hideIfNoImage,
  isMock,
  palette = 'primary',
}) => {
  const url = property?.photo?.cdnUrl || property?.photo?.url;
  if (!url && hideIfNoImage) return null;

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        bgcolor: (theme) => `${palette}.${theme.palette.mode}`,
        ...imageStyle,
      }}
    >
      {url ? (
        <img
          src={url}
          alt={property?.photo?.filename}
          style={{ height: 200, objectFit: 'cover', ...imageStyle }}
        />
      ) : (
        isMock
          // @ts-ignore
          ? <JobCardPractice viewBox="0 0 54 48" sx={{ fontSize: 60, ...placeholderStyle }} color="limitation" />
          : <HomeFilled sx={{ fontSize: 60, ...placeholderStyle }} color="disabled" />
      )}
      {showAddress && property && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            p: 1,
            bgcolor: 'rgba(0,0,0,0.5)',
          }}
        >
          <Typography fontWeight="bold" color="white" variant="body2">
            {property.street}
            <br />
            {property.city}, {property.state} {property.zipCode}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
